import { PortfolioModel } from '../shared/models/portfolio-model';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PortfolioListRecordModel } from '../shared/models/portfolio-list-record-model';
import { LookupService } from '../../shared/services/lookup.service';
import { PortfolioService } from '../shared/services/portfolio.service';

@Component({
  selector: 'hr-portfolio-list',
  templateUrl: './portfolio-list.component.html',
  styleUrls: ['./portfolio-list.component.less'],
  standalone: false,
})
export class PortfolioListComponent implements OnInit {
  public portfolios: PortfolioListRecordModel[];
  public displayModal: boolean;
  public selectedPortfolio: PortfolioModel;

  constructor(
    private lookupService: LookupService,
    private portfolioService: PortfolioService
  ) {}

  ngOnInit() {
    let lookupData = this.lookupService.getCachedLookupData();
    this.load();
  }

  public load() {
    this.portfolioService.listPortfolios().subscribe((p) => {
      this.portfolios = p.items;
    });
  }

  public onAddPortfolio(display: boolean) {
    this.displayModal = display;
  }

  public onCloseModal(display: boolean) {
    this.displayModal = display;
  }

  public onUpdateTable(display: boolean) {
    this.load();
  }

  public onEditAccountManagerClick(isInEditMode: boolean) {
    isInEditMode = true;
  }

  public onPortfolioAccountManagerUpdated() {
    this.load();
  }
}
